module.exports = __webpack_public_path__ + "img/myanmar.3fa15f59.svg";